var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseRunning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_d_7066_3871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 18.5107C23.201 18.6367 23.3375 18.7555 23.4766 18.867C24.5517 19.7293 25.7002 20.0997 26.7943 20.1583C28.6362 20.2569 30.2747 19.4349 30.9407 19.1008C31.016 19.0631 31.0788 19.0316 31.1282 19.0083C31.9607 18.6156 32.3172 17.6223 31.9245 16.7898C31.5317 15.9573 30.5385 15.6008 29.706 15.9936C29.6147 16.0367 29.5221 16.0813 29.4281 16.1267C28.6912 16.4824 27.8719 16.8779 26.9727 16.8297C26.5347 16.8062 26.0628 16.6682 25.5622 16.2667C25.0412 15.8488 24.4189 15.0874 23.8171 13.707C23.3293 12.5882 22.6033 11.7213 21.5717 11.2294C20.5828 10.758 19.531 10.7377 18.5937 10.849C16.0814 11.1472 14.1725 12.604 12.8741 13.9568C11.8051 15.0708 11.0074 16.2792 10.6163 16.8718C10.5367 16.9923 10.4739 17.0874 10.4292 17.151C9.89915 17.9036 10.0796 18.9433 10.8321 19.4733C11.5847 20.0033 12.6244 19.823 13.1544 19.0704C13.2476 18.9382 13.3501 18.7839 13.4642 18.6123C13.8809 17.9855 14.4517 17.1271 15.279 16.265C15.9307 15.5858 16.6604 14.9986 17.464 14.6126C17.2781 15.1246 17.0671 15.7065 16.8534 16.2975C16.2371 18.0025 15.5502 19.9149 15.4395 20.2977C15.3384 20.6472 15.3695 20.9461 15.3929 21.0952C15.4193 21.2635 15.4638 21.4058 15.4995 21.5056C15.5707 21.7047 15.665 21.8926 15.7479 22.0447C15.9182 22.3572 16.1512 22.7182 16.4021 23.0844C16.9106 23.8268 17.5953 24.7397 18.2745 25.6223C18.8743 26.4018 19.4852 27.1776 19.9877 27.8158L20.1891 28.0715C20.4588 28.4143 20.6845 28.7018 20.8505 28.9175C20.9253 29.0147 20.9762 29.0823 21.009 29.1263C21.0412 29.237 21.0823 29.3976 21.1313 29.6084C21.2287 30.0274 21.3409 30.5729 21.4592 31.1718C21.5353 31.557 21.6145 31.9675 21.6927 32.3733C21.8506 33.1922 22.0048 33.9927 22.1231 34.5273C22.3217 35.4262 23.2114 35.9937 24.1102 35.795C25.0089 35.5963 25.5765 34.7066 25.3778 33.8078C25.2692 33.3162 25.1309 32.599 24.9797 31.814C24.8992 31.3959 24.8148 30.9585 24.7294 30.5258C24.6099 29.9209 24.4887 29.3299 24.3781 28.8538C24.3231 28.617 24.2664 28.3902 24.2098 28.1958C24.1688 28.0548 24.0827 27.7631 23.9377 27.5096C23.8342 27.3288 23.6346 27.0695 23.4993 26.8938L23.4917 26.8841C23.3132 26.6521 23.0767 26.3508 22.8086 26.0101L22.6059 25.7527L22.6054 25.752C22.1021 25.1128 21.5037 24.3529 20.9162 23.5895C20.8517 23.5056 20.7874 23.4218 20.7236 23.3384L23.067 18.5107Z",
    stroke: "#040E64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1727 28.6095L14.7937 25.3027L14.1098 27.2687L9.96532 26.2947C9.06924 26.0841 8.17216 26.6398 7.96157 27.5358C7.75098 28.4319 8.30666 29.3291 9.20274 29.5397L14.8092 30.8572C15.6401 31.0525 16.4842 30.5886 16.7647 29.7824L17.1727 28.6095Z",
    stroke: "#040E64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6676 10.0007C28.0483 10.0007 29.1676 8.8814 29.1676 7.50065C29.1676 6.11994 28.0483 5.00065 26.6676 5.00065C25.2869 5.00065 24.1676 6.11994 24.1676 7.50065C24.1676 8.8814 25.2869 10.0007 26.6676 10.0007ZM26.6676 11.6673C28.9688 11.6673 30.8343 9.80182 30.8343 7.50065C30.8343 5.19947 28.9688 3.33398 26.6676 3.33398C24.3665 3.33398 22.501 5.19947 22.501 7.50065C22.501 9.80182 24.3665 11.6673 26.6676 11.6673Z",
    fill: "#040E64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7066_3871",
    x: -4,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7066_3871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7066_3871",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseRunning);
export default __webpack_public_path__ + "static/media/exercise_running.a0fbaac1ad5343dcccec1e543622f648.svg";
export { ForwardRef as ReactComponent };